import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layers, RotateCcw } from "lucide-react";
import { useWallet } from "@/context/WalletContext";
import PinPad from "@/components/PinPad";

export default function Unlock() {
  const nav = useNavigate();
  const { unlock, reset } = useWallet();
  const [err, setErr] = useState("");

  const handle = (pin) => {
    if (unlock(pin)) {
      nav("/portfolio", { replace: true });
    } else {
      setErr("Incorrect PIN");
    }
  };

  return (
    <div className="cw-shell min-h-screen items-center justify-center px-6 py-10">
      <div className="fade-up flex flex-col items-center">
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-neon/40 bg-neon/5 neon-glow">
          <Layers className="h-8 w-8 text-neon" />
        </div>
        <h1 className="font-outfit text-2xl font-extrabold">Welcome back</h1>
        <p className="mb-10 mt-1 font-sans text-sm text-[#9CA3AF]">Enter your PIN to unlock CoreWallet</p>

        <PinPad error={err} onComplete={handle} />

        <button
          data-testid="unlock-reset-button"
          onClick={() => {
            if (window.confirm("Reset wallet? You'll need your recovery phrase to restore it.")) {
              reset();
              nav("/onboarding", { replace: true });
            }
          }}
          className="mt-12 flex items-center gap-1.5 font-sans text-xs text-[#6B7280] hover:text-[#EF4444]"
        >
          <RotateCcw className="h-3.5 w-3.5" /> Reset / restore with recovery phrase
        </button>
      </div>
    </div>
  );
}
